import { render, staticRenderFns } from "./CommercialButtons.vue?vue&type=template&id=ed5018d0&lang=html&"
import script from "./CommercialButtons.vue?vue&type=script&lang=js&"
export * from "./CommercialButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports